export const responsiveMixin = {
  created() {
    window.addEventListener("resize", this.setBreakpointToggle);
    this.setBreakpointToggle();
  },

  unmounted() {
    window.removeEventListener("resize", this.setBreakpointToggle);
  },

  data() {
    return {
      isBelowMdBreakpoint: false,
      isTabletBreakpoint: false,
    };
  },

  provide() {
    return {
      isViewportMobile: () => this.isBelowMdBreakpoint,
      isViewportTablet: () => this.isTabletBreakpoint,
      isViewportMobileOrTablet: () => this.isBelowMdBreakpoint || this.isTabletBreakpoint,
      isViewportDesktop: () => !this.isBelowMdBreakpoint && !this.isTabletBreakpoint,
    };
  },

  methods: {
    setBreakpointToggle() {
      this.isBelowMdBreakpoint = window.matchMedia("(max-width: 767.98px)").matches;
      this.isTabletBreakpoint = window.matchMedia("(min-width:767.98px) and (max-width: 991px)").matches;
    },
  },
};
